import React, { useContext, useState, useEffect} from 'react'
import { connect } from 'react-redux'
import { Divider, Loader, Modal, Dimmer, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';
import { backendService } from '../../services/backendService';
import { logout } from '../../actions/actionCreators'

const ProfileDeletionConfirmDialog = (props) => {
  const languageContext = useContext(LanguageContext);

  
  const [visible, setVisible] = useState(props.visible ? props.visible : false);
  const [processing, setProcessing] = useState(props.processing ? props.processing : false);

  const handleDialogClose = () => {
    setVisible(false);
    if (props.dialogCloseCallback)
        props.dialogCloseCallback();
  }

  const deleteAccount = () => {
    setProcessing(true);
    backendService.delete(`/api/lawyers/${props.auth.user.id}`).then( response => {
      if (response.data && response.data.success) {
        NotificationManager.success(Translate(languageContext, 'subscription_cancellation_success_message'))
        setTimeout(function () {
          props.dispatch(logout())
        }, 3000);        
      } else {
        handleDialogClose();
        setProcessing(false);
        NotificationManager.error(Translate(languageContext, 'subscription_cancellation_fail_message'))
      }
    }, e => {
        handleDialogClose();
        setProcessing(true);
        NotificationManager.error(Translate(languageContext, 'subscription_cancellation_fail_message'))
    })
  }

  return (      
    <Modal
        open={visible}
        onClose={handleDialogClose}
        className='lisia-modal lisia-dialog'
    >
        <Modal.Content>
        <Dimmer.Dimmable dimmed={processing}>
            <h3 className='text-center'>{props.auth.user.name}<Text tid='do_you_hate_us' /></h3>
            <Divider />                            
            <h5 className='text-center'><Text tid='help_us' /></h5>
            <h5 className='text-center'><Text tid='tell_us_your_problems' /></h5>
            <Dimmer active={processing} inverted>
            <Loader size='large'><Text tid='loading' /></Loader>
            </Dimmer>
        </Dimmer.Dimmable>
        <Button disabled={processing} negative onClick={deleteAccount} style={{width: '100%'}}><Text tid='subscription_delete_your_account' /></Button>
        </Modal.Content>
        <Modal.Actions>
        <div className='footer'>
            <Link onClick={handleDialogClose} to='#'>
                <Text tid="back" />
            </Link>  
        </div>
        </Modal.Actions>
    </Modal> 
  )

}

const mapStateToProps = (state) => ({
  auth: state.auth,
  passwordRestore: state.passwordRestore
})

export default connect(mapStateToProps)(ProfileDeletionConfirmDialog);
